module.exports = function () {
    // get slides and controls
    const slides = document.querySelectorAll('.featured_carousel-item');

    if (slides.length > 0) {
        const nextSlide = document.querySelector('.btn-next');
        const prevSlide = document.querySelector('.btn-prev');

        // loop through and set css prop
        slides.forEach((slide, index) => {
            slide.style.transform = `translateX(${index * 33}%)`;
        });

        let currentSlide = 0;
        let maxSlides = slides.length - 1;

        nextSlide.addEventListener('click', function () {
            if (currentSlide === maxSlides) {
                currentSlide = 0;
            } else {
                currentSlide++;
            }

            slides.forEach((slide, index) => {
                slide.style.transform = `translateX(${33 * (index - currentSlide)}%)`;
            })
        })

        prevSlide.addEventListener('click', function () {
            if (currentSlide === 0) {
                currentSlide = maxSlides;
            } else {
                currentSlide--;
            }

            slides.forEach((slide, index) => {
                slide.style.transform = `translateX(${33 * (index - currentSlide)}%)`;
            });
        });
    };
};
